export const isWhitespaceString = (str) => {
  return !str.replace(/\s/g, "").length;
};
